// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LeadGeneration_leadWrapper__hkG\\+X {
  height: auto;
  display: flex;
  flex-direction: column;
  padding: 20px;
  overflow: hidden;
  min-height: 300px;
}

.LeadGeneration_title__F0KqF {
  font-size: 1.8rem;
  font-weight: 600;
  margin-bottom: 1.5rem;
  color: var(--dark-color);
  text-align: center;
}

.LeadGeneration_exportButtons__pWXA9 {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin: 1.5rem 0;
}

.LeadGeneration_leadsContainer__26QJH {
  flex: 1 1;
  overflow: auto;
  background: var(--white-color);
  border: 1px solid #ddd;
  border-radius: 6px;
  padding: 0;
  box-shadow: var(--shadow-md);
  min-height: 200px;
  max-height: 500px;
}

.LeadGeneration_leadsTable__Pr4pr {
  width: 100%;
  /* border-collapse: collapse; */
  table-layout: fixed;
  border: 1px solid #ddd;
}

.LeadGeneration_leadsTable__Pr4pr th,
.LeadGeneration_leadsTable__Pr4pr td {
  border: 1px solid #ddd;
  padding: 10px;
  text-align: left;
  vertical-align: top;
  word-wrap: break-word;
  overflow-wrap: break-word;
  max-width: 200px;
}

/* Column width distribution */
.LeadGeneration_leadsTable__Pr4pr th:nth-child(1),
.LeadGeneration_leadsTable__Pr4pr td:nth-child(1) {
  width: 15%;
}

.LeadGeneration_leadsTable__Pr4pr th:nth-child(2),
.LeadGeneration_leadsTable__Pr4pr td:nth-child(2) {
  width: 20%;
}

.LeadGeneration_leadsTable__Pr4pr th:nth-child(3),
.LeadGeneration_leadsTable__Pr4pr td:nth-child(3) {
  width: 40%;
}

.LeadGeneration_leadsTable__Pr4pr th:nth-child(4),
.LeadGeneration_leadsTable__Pr4pr td:nth-child(4) {
  width: 25%;
}

.LeadGeneration_leadsTable__Pr4pr th {
  background-color: #f4f4f4;
  color: #333;
  font-weight: 600;
  position: sticky;
  top: 0;
  z-index: 1;
  border-bottom: 2px solid #ddd;
}

.LeadGeneration_leadsTable__Pr4pr td {
  /* background-color: #fff; */
  border-bottom: 1px solid #eee;
}

/* Alternating row colors */
.LeadGeneration_leadsTable__Pr4pr tbody tr:nth-child(even) {
  background-color: #f9f9f9;
}

.LeadGeneration_leadsTable__Pr4pr tbody tr:nth-child(even) td {
  background-color: #f9f9f9;
}

.LeadGeneration_leadsTable__Pr4pr tbody tr:hover td {
  background-color: #eef6ff;
}

.LeadGeneration_leadsTable__Pr4pr td pre {
  margin: 0;
  white-space: pre-wrap;
  word-wrap: break-word;
  overflow-wrap: break-word;
  max-height: 100px;
  overflow-y: auto;
  font-size: 0.8rem;
  background: #f8f9fa;
  padding: 8px;
  border-radius: 4px;
  border: 1px solid #e9ecef;
}

.LeadGeneration_leadsTable__Pr4pr td pre::-webkit-scrollbar {
  width: 4px;
}

.LeadGeneration_leadsTable__Pr4pr td pre::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 2px;
}

.LeadGeneration_leadsTable__Pr4pr td pre::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 2px;
}

.LeadGeneration_leadsTable__Pr4pr td pre::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

.LeadGeneration_exportButtons__pWXA9 button {
  padding: 10px 16px;
  font-size: 14px;
  background-color: #0070f3;
  color: #fff;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.LeadGeneration_exportButtons__pWXA9 button:hover {
  background-color: #005ac1;
}

/* ---------------- Bot Form Section ---------------- */

.LeadGeneration_botFormSection__odb1\\+ {
  background: var(--white-color);
  border: 1px solid #e2e2e2;
  border-radius: 6px;
  padding: 16px;
  box-shadow: var(--shadow-md);
  transition: border-color 0.2s ease;
  margin-bottom: 20px;
  max-height: 400px;
  overflow-y: auto;
}

.LeadGeneration_botFormSection__odb1\\+ h3 {
  font-size: 18px;
  color: var(--dark2-color);
  margin-bottom: 15px;
  text-align: left;
  font-weight: 600;
}

.LeadGeneration_formsGrid__SSoKT {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.LeadGeneration_botFormCard__CXlXa {
  background-color: #e6edff;
  border: 1px solid #a3bdff;
  border-radius: 10px;
  padding: 15px 20px;
  transition: all 0.2s ease;
}

.LeadGeneration_cardAccordionHeader__saqzU {
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  padding: 5px 0;
}

.LeadGeneration_cardAccordionHeader__saqzU p {
  margin: 0;
  font-weight: 600;
  font-size: 1rem;
  color: #2c3e50;
}

.LeadGeneration_cardArrow__Uzxnf {
  transition: transform 0.3s;
  color: #666;
}

.LeadGeneration_cardArrow__Uzxnf.LeadGeneration_open__t6kII {
  transform: rotate(180deg);
}

.LeadGeneration_cardAccordionBody__JXkJA {
  margin-top: 10px;
  padding: 15px;
  background: #fff;
  border-radius: 8px;
  border: 1px solid #ddd;
}

.LeadGeneration_fieldsList__1sIYg h5 {
  margin: 0 0 0.5rem 0;
  color: #34495e;
  font-size: 0.9rem;
}

.LeadGeneration_fieldsList__1sIYg ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.LeadGeneration_fieldItem__Pro8J {
  padding: 0.5rem;
  margin-bottom: 0.5rem;
  background: #fff;
  border-radius: 4px;
  border-left: 4px solid #3498db;
  border-bottom: 1px solid #eee;
}

.LeadGeneration_fieldItem__Pro8J:last-child {
  border-bottom: none;
}

.LeadGeneration_fieldLabel__LhV62 {
  font-weight: 600;
  color: #2c3e50;
  display: block;
}

.LeadGeneration_fieldType__KNsKm {
  color: #7f8c8d;
  font-size: 0.85rem;
  margin-left: 0.5rem;
}

.LeadGeneration_requiredBadge__fk18- {
  background: #e74c3c;
  color: #fff;
  padding: 0.2rem 0.5rem;
  border-radius: 12px;
  font-size: 0.7rem;
  margin-left: 0.5rem;
  display: inline-block;
}

.LeadGeneration_placeholder__GFxKk {
  color: #95a5a6;
  font-size: 0.8rem;
  font-style: italic;
  margin-top: 10px;
}

.LeadGeneration_noFields__fw7P9 {
  color: #7f8c8d;
  font-style: italic;
  margin: 0;
}

.LeadGeneration_noForms__Cp-uT {
  color: #7f8c8d;
  font-style: italic;
  text-align: center;
  padding: 2rem;
}

.LeadGeneration_loaderContainer__gh9l9 {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 2rem;
}

.LeadGeneration_error__3YSwa {
  color: #e74c3c;
  text-align: center;
  padding: 1rem;
  background: #fdf2f2;
  border: 1px solid #f5c6cb;
  border-radius: 4px;
}

.LeadGeneration_formHeader__KFojk {
  display: flex;
  margin-bottom: 1rem;
  padding-bottom: 0.5rem;
  flex-direction: column;
}

.LeadGeneration_formActions__3KdxX {
  display: inline-flex;
  gap: 0.5rem;
  justify-content: flex-end;
}

.LeadGeneration_editBtn__ZQaXH,
.LeadGeneration_deleteBtn__pvNj6 {
  border: none;
  cursor: pointer;
  transition: all 0.2s ease;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  color: #555;
}

.LeadGeneration_editBtn__ZQaXH:hover {
  background: #e3f2fd;
  color: #1976d2;
}

.LeadGeneration_deleteBtn__pvNj6:hover {
  background: #fde8e8;
  color: #d32f2f;
}

.LeadGeneration_saveBtn__o1jRF,
.LeadGeneration_cancelBtn__AE46W {
  border: none;
  cursor: pointer;
  transition: all 0.2s ease;
  padding: 8px 20px;
  border-radius: 6px;
  font-weight: 500;
}

.LeadGeneration_saveBtn__o1jRF {
  background: #007bff;
  color: #fff;
}

.LeadGeneration_saveBtn__o1jRF:hover:not(:disabled) {
  background: #0056b3;
}

.LeadGeneration_saveBtn__o1jRF:disabled {
  background: #6c757d;
  cursor: not-allowed;
}

.LeadGeneration_cancelBtn__AE46W {
  background: #6c757d;
  color: #fff;
}

.LeadGeneration_cancelBtn__AE46W:hover {
  background: #545b62;
}

.LeadGeneration_preferencesEditor__tLhnB {
  margin-top: 1rem;
  padding: 1rem;
  background: #f8f9fa;
  border-radius: 6px;
  border-left: 4px solid #007bff;
}

.LeadGeneration_preferencesEditor__tLhnB h5 {
  margin: 0 0 1rem 0;
  color: #495057;
}

.LeadGeneration_preferenceActions__jJUni {
  display: flex;
  gap: 0.5rem;
  margin-top: 1rem;
  justify-content: flex-end;
}

.LeadGeneration_preferencesDisplay__20KMe {
  margin-top: 1rem;
  padding: 1rem;
  background: #e8f5e8;
  border-radius: 6px;
  border: 1px solid #c8e6c9;
}

.LeadGeneration_preferencesDisplay__20KMe h5 {
  margin: 0 0 0.8rem 0;
  color: #155724;
}

.LeadGeneration_noPreferences__9dvED {
  margin-top: 1rem;
  padding: 1rem;
  background: #fff3cd;
  border-radius: 6px;
  border-left: 4px solid #ffc107;
  color: #856404;
}

.LeadGeneration_noPreferences__9dvED p {
  margin: 0;
  font-size: 0.9rem;
}

.LeadGeneration_accordionHeader__w6IDR {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #f0f0f0;
  padding: 8px 12px;
  cursor: pointer;
  border-radius: 6px;
  transition: background 0.3s;
  border: 1px solid #e0e0e0;
}

.LeadGeneration_accordionHeader__w6IDR:hover {
  background: #e8e8e8;
}

.LeadGeneration_arrow__yEltV {
  transition: transform 0.3s ease;
  font-size: 16px;
  color: #666;
}

.LeadGeneration_arrow__yEltV.LeadGeneration_open__t6kII {
  transform: rotate(180deg);
}

.LeadGeneration_accordionBody__hOBN- {
  margin-top: 8px;
  padding: 8px 12px;
  border-left: 2px solid #ddd;
  animation: LeadGeneration_fadeIn__BUCc5 0.25s ease;
}

@keyframes LeadGeneration_fadeIn__BUCc5 {
  from {
    opacity: 0;
    transform: translateY(-4px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.LeadGeneration_formUuid__ka\\+QW {
  margin-bottom: 0.5rem;
  padding: 0.3rem 0.5rem;
  border-radius: 4px;
  font-family: monospace;
  font-size: 0.8rem;
  color: #666;
  background: #f8f9fa;
  border: 1px solid #e9ecef;
}

.LeadGeneration_formUuid__ka\\+QW small {
  font-size: 0.75rem;
}

.LeadGeneration_templateDescription__EeBen {
  color: #666;
  margin-bottom: 1rem;
  font-size: 0.9rem;
}

.LeadGeneration_templateOptions__Xz3j1 {
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
  margin-bottom: 1.5rem;
}

.LeadGeneration_templateLabel__1nt8y {
  display: flex;
  align-items: center;
  gap: 0.8rem;
  cursor: pointer;
  margin: 0;
}

.LeadGeneration_templateRadio__d9ieE {
  margin-top: 0.2rem;
  cursor: pointer;
}

.LeadGeneration_templateContent__iWxNH {
  flex: 1 1;
  border: 2px solid #e9ecef;
  border-radius: 8px;
  padding: 0.8rem;
  transition: all 0.2s ease;
  cursor: pointer;
}

.LeadGeneration_templateContent__iWxNH:hover {
  border-color: #007bff;
  background-color: #f8f9fa;
}

.LeadGeneration_templateContent__iWxNH:has(.LeadGeneration_templateRadio__d9ieE:checked) {
  border-color: #007bff;
  background-color: #e7f3ff;
}

.LeadGeneration_templateName__smmUq {
  display: block;
  font-size: 0.95rem;
  margin-bottom: 0.3rem;
  text-transform: capitalize;
  font-weight: 600;
  color: #333;
}

.LeadGeneration_templateDesc__fbyWn {
  color: #6c757d;
  font-size: 0.85rem;
  margin: 0;
  line-height: 1.4;
}

.LeadGeneration_templateDisplay__3GLei {
  margin-bottom: 1rem;
}

.LeadGeneration_templateBadge__GyciF {
  display: inline-block;
  background: #007bff;
  color: #fff;
  padding: 0.3rem 0.8rem;
  border-radius: 20px;
  font-size: 0.8rem;
  font-weight: 600;
  text-transform: capitalize;
  margin-bottom: 0.5rem;
}

.LeadGeneration_preferenceStructure__6MO08 {
  margin-top: 1rem;
  padding: 0.8rem;
  background: #f8f9fa;
  border-radius: 6px;
  border-left: 3px solid #28a745;
  text-align: center;
}

.LeadGeneration_preferenceStructure__6MO08 strong {
  display: block;
  margin-bottom: 0.5rem;
  color: #495057;
}

.LeadGeneration_structureCode__Joj-W {
  background: #fff;
  padding: 0.8rem;
  border-radius: 4px;
  border: 1px solid #dee2e6;
  font-size: 0.8rem;
  margin: 0;
  overflow-x: auto;
  max-height: 120px;
  overflow-y: auto;
  text-align: left;
  white-space: pre-wrap;
  word-wrap: break-word;
  font-family: "Courier New", monospace;
  background: #f8f9fa;
}

/* ========== RESPONSIVE ========== */

@media (max-width: 1024px) {
  .LeadGeneration_leadWrapper__hkG\\+X {
    padding: 16px;
  }

  .LeadGeneration_exportButtons__pWXA9 {
    flex-direction: column;
    gap: 10px;
    align-items: center;
  }

  .LeadGeneration_exportButtons__pWXA9 button {
    width: 100%;
    max-width: 200px;
  }

  .LeadGeneration_leadsContainer__26QJH {
    max-height: 400px;
  }
}

@media (max-width: 768px) {
  .LeadGeneration_leadWrapper__hkG\\+X {
    padding: 12px;
  }

  .LeadGeneration_title__F0KqF {
    font-size: 20px;
    margin-bottom: 16px;
  }

  .LeadGeneration_exportButtons__pWXA9 {
    flex-direction: column;
    align-items: center;
    gap: 10px;
    margin-bottom: 16px;
  }

  .LeadGeneration_exportButtons__pWXA9 button {
    width: 100%;
    max-width: 300px;
    font-size: 16px;
    padding: 12px 16px;
  }

  .LeadGeneration_leadsContainer__26QJH {
    max-height: 350px;
    padding: 0;
  }

  .LeadGeneration_leadsTable__Pr4pr {
    min-width: 600px;
    border: 1px solid #ddd;
  }

  .LeadGeneration_leadsTable__Pr4pr th,
  .LeadGeneration_leadsTable__Pr4pr td {
    padding: 8px;
    font-size: 12px;
    max-width: 150px;
  }

  .LeadGeneration_leadsTable__Pr4pr td pre {
    font-size: 0.7rem;
    max-height: 80px;
    padding: 6px;
  }

  .LeadGeneration_botFormSection__odb1\\+ {
    max-height: 300px;
    padding: 12px;
  }

  .LeadGeneration_botFormCard__CXlXa {
    padding: 12px 14px;
  }

  .LeadGeneration_cardAccordionHeader__saqzU p {
    font-size: 0.9rem;
  }

  .LeadGeneration_cardAccordionBody__JXkJA {
    padding: 10px;
  }

  .LeadGeneration_formActions__3KdxX {
    gap: 0.3rem;
  }

  .LeadGeneration_editBtn__ZQaXH,
  .LeadGeneration_deleteBtn__pvNj6 {
    width: 32px;
    height: 32px;
  }

  .LeadGeneration_preferenceActions__jJUni {
    flex-direction: column;
  }

  .LeadGeneration_saveBtn__o1jRF,
  .LeadGeneration_cancelBtn__AE46W {
    width: 100%;
  }

  .LeadGeneration_templateOptions__Xz3j1 {
    gap: 0.6rem;
  }

  .LeadGeneration_templateContent__iWxNH {
    padding: 0.6rem;
  }

  .LeadGeneration_structureCode__Joj-W {
    font-size: 0.7rem;
    padding: 0.6rem;
  }

  .LeadGeneration_formHeader__KFojk {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.5rem;
  }

  .LeadGeneration_formActions__3KdxX {
    width: 100%;
    justify-content: flex-end;
  }
}

@media (max-width: 480px) {
  .LeadGeneration_leadWrapper__hkG\\+X {
    padding: 0px;
    height: 100%;
    /* min-height: 100vh; */
  }

  .LeadGeneration_title__F0KqF {
    font-size: 1.4rem;
  }

  .LeadGeneration_leadsTable__Pr4pr {
    min-width: 500px;
    border: 1px solid #ddd;
  }

  .LeadGeneration_leadsTable__Pr4pr th,
  .LeadGeneration_leadsTable__Pr4pr td {
    padding: 6px;
    font-size: 11px;
  }

  .LeadGeneration_leadsTable__Pr4pr td pre {
    font-size: 0.65rem;
    max-height: 60px;
    padding: 4px;
  }

  .LeadGeneration_leadsContainer__26QJH {
    max-height: 300px;
    padding: 0;
  }

  .LeadGeneration_botFormSection__odb1\\+ {
    max-height: 250px;
    padding: 10px;
  }

  .LeadGeneration_botFormCard__CXlXa {
    padding: 8px 10px;
  }

  .LeadGeneration_cardAccordionHeader__saqzU {
    min-width: auto;
  }

  .LeadGeneration_cardAccordionHeader__saqzU p {
    font-size: 0.85rem;
  }

  .LeadGeneration_cardAccordionBody__JXkJA {
    margin: 8px 0;
    padding: 8px;
  }

  .LeadGeneration_accordionBody__hOBN- {
    padding: 0px;
    border-left: none;
  }

  .LeadGeneration_fieldItem__Pro8J {
    padding: 0.3rem;
    font-size: 0.8rem;
  }

  .LeadGeneration_preferencesEditor__tLhnB {
    padding: 0.8rem;
  }

  .LeadGeneration_preferencesDisplay__20KMe {
    padding: 0.8rem;
  }

  .LeadGeneration_structureCode__Joj-W {
    max-height: 80px;
  }

  .LeadGeneration_exportButtons__pWXA9 button {
    font-size: 14px;
    padding: 10px 14px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Component/SideData/Overview/LeadGeneration/LeadGeneration.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,cAAc;EACd,8BAA8B;EAC9B,sBAAsB;EACtB,kBAAkB;EAClB,UAAU;EACV,4BAA4B;EAC5B,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,+BAA+B;EAC/B,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;;EAEE,sBAAsB;EACtB,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;EACrB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA,8BAA8B;AAC9B;;EAEE,UAAU;AACZ;;AAEA;;EAEE,UAAU;AACZ;;AAEA;;EAEE,UAAU;AACZ;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA,2BAA2B;AAC3B;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,qBAAqB;EACrB,qBAAqB;EACrB,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,uDAAuD;;AAEvD;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,4BAA4B;EAC5B,kCAAkC;EAClC,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,8BAA8B;EAC9B,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,sBAAsB;EACtB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,WAAW;EACX,yBAAyB;AAC3B;;AAEA;;EAEE,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;EAEE,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,eAAe;EACf,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,2BAA2B;EAC3B,kDAA4B;AAC9B;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;EACtB,iBAAiB;EACjB,WAAW;EACX,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,qBAAqB;EACrB,0BAA0B;EAC1B,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,WAAW;EACX,sBAAsB;EACtB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;EAC1B,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;EACjB,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;EACrB,qBAAqB;EACrB,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA,qCAAqC;;AAErC;EACE;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,UAAU;EACZ;;EAEA;IACE,gBAAgB;IAChB,sBAAsB;EACxB;;EAEA;;IAEE,YAAY;IACZ,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;EACd;;EAEA;IACE,iBAAiB;IACjB,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;EACb;;EAEA;;IAEE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,sBAAsB;EACxB;;EAEA;;IAEE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,WAAW;EACb;;EAEA;IACE,WAAW;IACX,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,YAAY;IACZ,YAAY;IACZ,uBAAuB;EACzB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,sBAAsB;EACxB;;EAEA;;IAEE,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;EACd;;EAEA;IACE,iBAAiB;IACjB,UAAU;EACZ;;EAEA;IACE,iBAAiB;IACjB,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;AACF","sourcesContent":[".leadWrapper {\n  height: auto;\n  display: flex;\n  flex-direction: column;\n  padding: 20px;\n  overflow: hidden;\n  min-height: 300px;\n}\n\n.title {\n  font-size: 1.8rem;\n  font-weight: 600;\n  margin-bottom: 1.5rem;\n  color: var(--dark-color);\n  text-align: center;\n}\n\n.exportButtons {\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n  margin: 1.5rem 0;\n}\n\n.leadsContainer {\n  flex: 1;\n  overflow: auto;\n  background: var(--white-color);\n  border: 1px solid #ddd;\n  border-radius: 6px;\n  padding: 0;\n  box-shadow: var(--shadow-md);\n  min-height: 200px;\n  max-height: 500px;\n}\n\n.leadsTable {\n  width: 100%;\n  /* border-collapse: collapse; */\n  table-layout: fixed;\n  border: 1px solid #ddd;\n}\n\n.leadsTable th,\n.leadsTable td {\n  border: 1px solid #ddd;\n  padding: 10px;\n  text-align: left;\n  vertical-align: top;\n  word-wrap: break-word;\n  overflow-wrap: break-word;\n  max-width: 200px;\n}\n\n/* Column width distribution */\n.leadsTable th:nth-child(1),\n.leadsTable td:nth-child(1) {\n  width: 15%;\n}\n\n.leadsTable th:nth-child(2),\n.leadsTable td:nth-child(2) {\n  width: 20%;\n}\n\n.leadsTable th:nth-child(3),\n.leadsTable td:nth-child(3) {\n  width: 40%;\n}\n\n.leadsTable th:nth-child(4),\n.leadsTable td:nth-child(4) {\n  width: 25%;\n}\n\n.leadsTable th {\n  background-color: #f4f4f4;\n  color: #333;\n  font-weight: 600;\n  position: sticky;\n  top: 0;\n  z-index: 1;\n  border-bottom: 2px solid #ddd;\n}\n\n.leadsTable td {\n  /* background-color: #fff; */\n  border-bottom: 1px solid #eee;\n}\n\n/* Alternating row colors */\n.leadsTable tbody tr:nth-child(even) {\n  background-color: #f9f9f9;\n}\n\n.leadsTable tbody tr:nth-child(even) td {\n  background-color: #f9f9f9;\n}\n\n.leadsTable tbody tr:hover td {\n  background-color: #eef6ff;\n}\n\n.leadsTable td pre {\n  margin: 0;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  overflow-wrap: break-word;\n  max-height: 100px;\n  overflow-y: auto;\n  font-size: 0.8rem;\n  background: #f8f9fa;\n  padding: 8px;\n  border-radius: 4px;\n  border: 1px solid #e9ecef;\n}\n\n.leadsTable td pre::-webkit-scrollbar {\n  width: 4px;\n}\n\n.leadsTable td pre::-webkit-scrollbar-track {\n  background: #f1f1f1;\n  border-radius: 2px;\n}\n\n.leadsTable td pre::-webkit-scrollbar-thumb {\n  background: #c1c1c1;\n  border-radius: 2px;\n}\n\n.leadsTable td pre::-webkit-scrollbar-thumb:hover {\n  background: #a8a8a8;\n}\n\n.exportButtons button {\n  padding: 10px 16px;\n  font-size: 14px;\n  background-color: #0070f3;\n  color: #fff;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n}\n\n.exportButtons button:hover {\n  background-color: #005ac1;\n}\n\n/* ---------------- Bot Form Section ---------------- */\n\n.botFormSection {\n  background: var(--white-color);\n  border: 1px solid #e2e2e2;\n  border-radius: 6px;\n  padding: 16px;\n  box-shadow: var(--shadow-md);\n  transition: border-color 0.2s ease;\n  margin-bottom: 20px;\n  max-height: 400px;\n  overflow-y: auto;\n}\n\n.botFormSection h3 {\n  font-size: 18px;\n  color: var(--dark2-color);\n  margin-bottom: 15px;\n  text-align: left;\n  font-weight: 600;\n}\n\n.formsGrid {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.botFormCard {\n  background-color: #e6edff;\n  border: 1px solid #a3bdff;\n  border-radius: 10px;\n  padding: 15px 20px;\n  transition: all 0.2s ease;\n}\n\n.cardAccordionHeader {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  cursor: pointer;\n  padding: 5px 0;\n}\n\n.cardAccordionHeader p {\n  margin: 0;\n  font-weight: 600;\n  font-size: 1rem;\n  color: #2c3e50;\n}\n\n.cardArrow {\n  transition: transform 0.3s;\n  color: #666;\n}\n\n.cardArrow.open {\n  transform: rotate(180deg);\n}\n\n.cardAccordionBody {\n  margin-top: 10px;\n  padding: 15px;\n  background: #fff;\n  border-radius: 8px;\n  border: 1px solid #ddd;\n}\n\n.fieldsList h5 {\n  margin: 0 0 0.5rem 0;\n  color: #34495e;\n  font-size: 0.9rem;\n}\n\n.fieldsList ul {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.fieldItem {\n  padding: 0.5rem;\n  margin-bottom: 0.5rem;\n  background: #fff;\n  border-radius: 4px;\n  border-left: 4px solid #3498db;\n  border-bottom: 1px solid #eee;\n}\n\n.fieldItem:last-child {\n  border-bottom: none;\n}\n\n.fieldLabel {\n  font-weight: 600;\n  color: #2c3e50;\n  display: block;\n}\n\n.fieldType {\n  color: #7f8c8d;\n  font-size: 0.85rem;\n  margin-left: 0.5rem;\n}\n\n.requiredBadge {\n  background: #e74c3c;\n  color: #fff;\n  padding: 0.2rem 0.5rem;\n  border-radius: 12px;\n  font-size: 0.7rem;\n  margin-left: 0.5rem;\n  display: inline-block;\n}\n\n.placeholder {\n  color: #95a5a6;\n  font-size: 0.8rem;\n  font-style: italic;\n  margin-top: 10px;\n}\n\n.noFields {\n  color: #7f8c8d;\n  font-style: italic;\n  margin: 0;\n}\n\n.noForms {\n  color: #7f8c8d;\n  font-style: italic;\n  text-align: center;\n  padding: 2rem;\n}\n\n.loaderContainer {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 2rem;\n}\n\n.error {\n  color: #e74c3c;\n  text-align: center;\n  padding: 1rem;\n  background: #fdf2f2;\n  border: 1px solid #f5c6cb;\n  border-radius: 4px;\n}\n\n.formHeader {\n  display: flex;\n  margin-bottom: 1rem;\n  padding-bottom: 0.5rem;\n  flex-direction: column;\n}\n\n.formActions {\n  display: inline-flex;\n  gap: 0.5rem;\n  justify-content: flex-end;\n}\n\n.editBtn,\n.deleteBtn {\n  border: none;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: transparent;\n  color: #555;\n}\n\n.editBtn:hover {\n  background: #e3f2fd;\n  color: #1976d2;\n}\n\n.deleteBtn:hover {\n  background: #fde8e8;\n  color: #d32f2f;\n}\n\n.saveBtn,\n.cancelBtn {\n  border: none;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  padding: 8px 20px;\n  border-radius: 6px;\n  font-weight: 500;\n}\n\n.saveBtn {\n  background: #007bff;\n  color: #fff;\n}\n\n.saveBtn:hover:not(:disabled) {\n  background: #0056b3;\n}\n\n.saveBtn:disabled {\n  background: #6c757d;\n  cursor: not-allowed;\n}\n\n.cancelBtn {\n  background: #6c757d;\n  color: #fff;\n}\n\n.cancelBtn:hover {\n  background: #545b62;\n}\n\n.preferencesEditor {\n  margin-top: 1rem;\n  padding: 1rem;\n  background: #f8f9fa;\n  border-radius: 6px;\n  border-left: 4px solid #007bff;\n}\n\n.preferencesEditor h5 {\n  margin: 0 0 1rem 0;\n  color: #495057;\n}\n\n.preferenceActions {\n  display: flex;\n  gap: 0.5rem;\n  margin-top: 1rem;\n  justify-content: flex-end;\n}\n\n.preferencesDisplay {\n  margin-top: 1rem;\n  padding: 1rem;\n  background: #e8f5e8;\n  border-radius: 6px;\n  border: 1px solid #c8e6c9;\n}\n\n.preferencesDisplay h5 {\n  margin: 0 0 0.8rem 0;\n  color: #155724;\n}\n\n.noPreferences {\n  margin-top: 1rem;\n  padding: 1rem;\n  background: #fff3cd;\n  border-radius: 6px;\n  border-left: 4px solid #ffc107;\n  color: #856404;\n}\n\n.noPreferences p {\n  margin: 0;\n  font-size: 0.9rem;\n}\n\n.accordionHeader {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  background: #f0f0f0;\n  padding: 8px 12px;\n  cursor: pointer;\n  border-radius: 6px;\n  transition: background 0.3s;\n  border: 1px solid #e0e0e0;\n}\n\n.accordionHeader:hover {\n  background: #e8e8e8;\n}\n\n.arrow {\n  transition: transform 0.3s ease;\n  font-size: 16px;\n  color: #666;\n}\n\n.arrow.open {\n  transform: rotate(180deg);\n}\n\n.accordionBody {\n  margin-top: 8px;\n  padding: 8px 12px;\n  border-left: 2px solid #ddd;\n  animation: fadeIn 0.25s ease;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(-4px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.formUuid {\n  margin-bottom: 0.5rem;\n  padding: 0.3rem 0.5rem;\n  border-radius: 4px;\n  font-family: monospace;\n  font-size: 0.8rem;\n  color: #666;\n  background: #f8f9fa;\n  border: 1px solid #e9ecef;\n}\n\n.formUuid small {\n  font-size: 0.75rem;\n}\n\n.templateDescription {\n  color: #666;\n  margin-bottom: 1rem;\n  font-size: 0.9rem;\n}\n\n.templateOptions {\n  display: flex;\n  flex-direction: column;\n  gap: 0.8rem;\n  margin-bottom: 1.5rem;\n}\n\n.templateLabel {\n  display: flex;\n  align-items: center;\n  gap: 0.8rem;\n  cursor: pointer;\n  margin: 0;\n}\n\n.templateRadio {\n  margin-top: 0.2rem;\n  cursor: pointer;\n}\n\n.templateContent {\n  flex: 1;\n  border: 2px solid #e9ecef;\n  border-radius: 8px;\n  padding: 0.8rem;\n  transition: all 0.2s ease;\n  cursor: pointer;\n}\n\n.templateContent:hover {\n  border-color: #007bff;\n  background-color: #f8f9fa;\n}\n\n.templateContent:has(.templateRadio:checked) {\n  border-color: #007bff;\n  background-color: #e7f3ff;\n}\n\n.templateName {\n  display: block;\n  font-size: 0.95rem;\n  margin-bottom: 0.3rem;\n  text-transform: capitalize;\n  font-weight: 600;\n  color: #333;\n}\n\n.templateDesc {\n  color: #6c757d;\n  font-size: 0.85rem;\n  margin: 0;\n  line-height: 1.4;\n}\n\n.templateDisplay {\n  margin-bottom: 1rem;\n}\n\n.templateBadge {\n  display: inline-block;\n  background: #007bff;\n  color: #fff;\n  padding: 0.3rem 0.8rem;\n  border-radius: 20px;\n  font-size: 0.8rem;\n  font-weight: 600;\n  text-transform: capitalize;\n  margin-bottom: 0.5rem;\n}\n\n.preferenceStructure {\n  margin-top: 1rem;\n  padding: 0.8rem;\n  background: #f8f9fa;\n  border-radius: 6px;\n  border-left: 3px solid #28a745;\n  text-align: center;\n}\n\n.preferenceStructure strong {\n  display: block;\n  margin-bottom: 0.5rem;\n  color: #495057;\n}\n\n.structureCode {\n  background: #fff;\n  padding: 0.8rem;\n  border-radius: 4px;\n  border: 1px solid #dee2e6;\n  font-size: 0.8rem;\n  margin: 0;\n  overflow-x: auto;\n  max-height: 120px;\n  overflow-y: auto;\n  text-align: left;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  font-family: \"Courier New\", monospace;\n  background: #f8f9fa;\n}\n\n/* ========== RESPONSIVE ========== */\n\n@media (max-width: 1024px) {\n  .leadWrapper {\n    padding: 16px;\n  }\n\n  .exportButtons {\n    flex-direction: column;\n    gap: 10px;\n    align-items: center;\n  }\n\n  .exportButtons button {\n    width: 100%;\n    max-width: 200px;\n  }\n\n  .leadsContainer {\n    max-height: 400px;\n  }\n}\n\n@media (max-width: 768px) {\n  .leadWrapper {\n    padding: 12px;\n  }\n\n  .title {\n    font-size: 20px;\n    margin-bottom: 16px;\n  }\n\n  .exportButtons {\n    flex-direction: column;\n    align-items: center;\n    gap: 10px;\n    margin-bottom: 16px;\n  }\n\n  .exportButtons button {\n    width: 100%;\n    max-width: 300px;\n    font-size: 16px;\n    padding: 12px 16px;\n  }\n\n  .leadsContainer {\n    max-height: 350px;\n    padding: 0;\n  }\n\n  .leadsTable {\n    min-width: 600px;\n    border: 1px solid #ddd;\n  }\n\n  .leadsTable th,\n  .leadsTable td {\n    padding: 8px;\n    font-size: 12px;\n    max-width: 150px;\n  }\n\n  .leadsTable td pre {\n    font-size: 0.7rem;\n    max-height: 80px;\n    padding: 6px;\n  }\n\n  .botFormSection {\n    max-height: 300px;\n    padding: 12px;\n  }\n\n  .botFormCard {\n    padding: 12px 14px;\n  }\n\n  .cardAccordionHeader p {\n    font-size: 0.9rem;\n  }\n\n  .cardAccordionBody {\n    padding: 10px;\n  }\n\n  .formActions {\n    gap: 0.3rem;\n  }\n\n  .editBtn,\n  .deleteBtn {\n    width: 32px;\n    height: 32px;\n  }\n\n  .preferenceActions {\n    flex-direction: column;\n  }\n\n  .saveBtn,\n  .cancelBtn {\n    width: 100%;\n  }\n\n  .templateOptions {\n    gap: 0.6rem;\n  }\n\n  .templateContent {\n    padding: 0.6rem;\n  }\n\n  .structureCode {\n    font-size: 0.7rem;\n    padding: 0.6rem;\n  }\n\n  .formHeader {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 0.5rem;\n  }\n\n  .formActions {\n    width: 100%;\n    justify-content: flex-end;\n  }\n}\n\n@media (max-width: 480px) {\n  .leadWrapper {\n    padding: 0px;\n    height: 100%;\n    /* min-height: 100vh; */\n  }\n\n  .title {\n    font-size: 1.4rem;\n  }\n\n  .leadsTable {\n    min-width: 500px;\n    border: 1px solid #ddd;\n  }\n\n  .leadsTable th,\n  .leadsTable td {\n    padding: 6px;\n    font-size: 11px;\n  }\n\n  .leadsTable td pre {\n    font-size: 0.65rem;\n    max-height: 60px;\n    padding: 4px;\n  }\n\n  .leadsContainer {\n    max-height: 300px;\n    padding: 0;\n  }\n\n  .botFormSection {\n    max-height: 250px;\n    padding: 10px;\n  }\n\n  .botFormCard {\n    padding: 8px 10px;\n  }\n\n  .cardAccordionHeader {\n    min-width: auto;\n  }\n\n  .cardAccordionHeader p {\n    font-size: 0.85rem;\n  }\n\n  .cardAccordionBody {\n    margin: 8px 0;\n    padding: 8px;\n  }\n\n  .accordionBody {\n    padding: 0px;\n    border-left: none;\n  }\n\n  .fieldItem {\n    padding: 0.3rem;\n    font-size: 0.8rem;\n  }\n\n  .preferencesEditor {\n    padding: 0.8rem;\n  }\n\n  .preferencesDisplay {\n    padding: 0.8rem;\n  }\n\n  .structureCode {\n    max-height: 80px;\n  }\n\n  .exportButtons button {\n    font-size: 14px;\n    padding: 10px 14px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"leadWrapper": `LeadGeneration_leadWrapper__hkG+X`,
	"title": `LeadGeneration_title__F0KqF`,
	"exportButtons": `LeadGeneration_exportButtons__pWXA9`,
	"leadsContainer": `LeadGeneration_leadsContainer__26QJH`,
	"leadsTable": `LeadGeneration_leadsTable__Pr4pr`,
	"botFormSection": `LeadGeneration_botFormSection__odb1+`,
	"formsGrid": `LeadGeneration_formsGrid__SSoKT`,
	"botFormCard": `LeadGeneration_botFormCard__CXlXa`,
	"cardAccordionHeader": `LeadGeneration_cardAccordionHeader__saqzU`,
	"cardArrow": `LeadGeneration_cardArrow__Uzxnf`,
	"open": `LeadGeneration_open__t6kII`,
	"cardAccordionBody": `LeadGeneration_cardAccordionBody__JXkJA`,
	"fieldsList": `LeadGeneration_fieldsList__1sIYg`,
	"fieldItem": `LeadGeneration_fieldItem__Pro8J`,
	"fieldLabel": `LeadGeneration_fieldLabel__LhV62`,
	"fieldType": `LeadGeneration_fieldType__KNsKm`,
	"requiredBadge": `LeadGeneration_requiredBadge__fk18-`,
	"placeholder": `LeadGeneration_placeholder__GFxKk`,
	"noFields": `LeadGeneration_noFields__fw7P9`,
	"noForms": `LeadGeneration_noForms__Cp-uT`,
	"loaderContainer": `LeadGeneration_loaderContainer__gh9l9`,
	"error": `LeadGeneration_error__3YSwa`,
	"formHeader": `LeadGeneration_formHeader__KFojk`,
	"formActions": `LeadGeneration_formActions__3KdxX`,
	"editBtn": `LeadGeneration_editBtn__ZQaXH`,
	"deleteBtn": `LeadGeneration_deleteBtn__pvNj6`,
	"saveBtn": `LeadGeneration_saveBtn__o1jRF`,
	"cancelBtn": `LeadGeneration_cancelBtn__AE46W`,
	"preferencesEditor": `LeadGeneration_preferencesEditor__tLhnB`,
	"preferenceActions": `LeadGeneration_preferenceActions__jJUni`,
	"preferencesDisplay": `LeadGeneration_preferencesDisplay__20KMe`,
	"noPreferences": `LeadGeneration_noPreferences__9dvED`,
	"accordionHeader": `LeadGeneration_accordionHeader__w6IDR`,
	"arrow": `LeadGeneration_arrow__yEltV`,
	"accordionBody": `LeadGeneration_accordionBody__hOBN-`,
	"fadeIn": `LeadGeneration_fadeIn__BUCc5`,
	"formUuid": `LeadGeneration_formUuid__ka+QW`,
	"templateDescription": `LeadGeneration_templateDescription__EeBen`,
	"templateOptions": `LeadGeneration_templateOptions__Xz3j1`,
	"templateLabel": `LeadGeneration_templateLabel__1nt8y`,
	"templateRadio": `LeadGeneration_templateRadio__d9ieE`,
	"templateContent": `LeadGeneration_templateContent__iWxNH`,
	"templateName": `LeadGeneration_templateName__smmUq`,
	"templateDesc": `LeadGeneration_templateDesc__fbyWn`,
	"templateDisplay": `LeadGeneration_templateDisplay__3GLei`,
	"templateBadge": `LeadGeneration_templateBadge__GyciF`,
	"preferenceStructure": `LeadGeneration_preferenceStructure__6MO08`,
	"structureCode": `LeadGeneration_structureCode__Joj-W`
};
export default ___CSS_LOADER_EXPORT___;
